//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export * as Client from './axios-client/Client';

export * as Query from './axios-client/Query';

//-----Types.File-----
export class HTTPError implements IHTTPError {
    message?: any | undefined;

    constructor(data?: IHTTPError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): HTTPError {
        data = typeof data === 'object' ? data : {};
        let result = new HTTPError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IHTTPError {
    message?: any | undefined;
}

export class ActivityGraphDataPoint implements IActivityGraphDataPoint {
    assessments?: number | undefined;
    courses?: number | undefined;
    date?: string | undefined;
    interviews?: number | undefined;

    constructor(data?: IActivityGraphDataPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessments = _data["assessments"];
            this.courses = _data["courses"];
            this.date = _data["date"];
            this.interviews = _data["interviews"];
        }
    }

    static fromJS(data: any): ActivityGraphDataPoint {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityGraphDataPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessments"] = this.assessments;
        data["courses"] = this.courses;
        data["date"] = this.date;
        data["interviews"] = this.interviews;
        return data;
    }
}

export interface IActivityGraphDataPoint {
    assessments?: number | undefined;
    courses?: number | undefined;
    date?: string | undefined;
    interviews?: number | undefined;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
    password_hash?: string | undefined;

    constructor(data?: IChangePasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password_hash = _data["password_hash"];
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password_hash"] = this.password_hash;
        return data;
    }
}

export interface IChangePasswordRequest {
    password_hash?: string | undefined;
}

export class ConversationAskQuestionRequest implements IConversationAskQuestionRequest {
    question?: string | undefined;
    subtopic?: string | undefined;
    topic?: string | undefined;

    constructor(data?: IConversationAskQuestionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"];
            this.subtopic = _data["subtopic"];
            this.topic = _data["topic"];
        }
    }

    static fromJS(data: any): ConversationAskQuestionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationAskQuestionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        data["subtopic"] = this.subtopic;
        data["topic"] = this.topic;
        return data;
    }
}

export interface IConversationAskQuestionRequest {
    question?: string | undefined;
    subtopic?: string | undefined;
    topic?: string | undefined;
}

export class ConversationAskQuestionResponse implements IConversationAskQuestionResponse {
    response?: string | undefined;

    constructor(data?: IConversationAskQuestionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.response = _data["response"];
        }
    }

    static fromJS(data: any): ConversationAskQuestionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationAskQuestionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["response"] = this.response;
        return data;
    }
}

export interface IConversationAskQuestionResponse {
    response?: string | undefined;
}

export class ConversationGenerateExampleRequest implements IConversationGenerateExampleRequest {
    subtopic?: string | undefined;
    topic?: string | undefined;

    constructor(data?: IConversationGenerateExampleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subtopic = _data["subtopic"];
            this.topic = _data["topic"];
        }
    }

    static fromJS(data: any): ConversationGenerateExampleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationGenerateExampleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subtopic"] = this.subtopic;
        data["topic"] = this.topic;
        return data;
    }
}

export interface IConversationGenerateExampleRequest {
    subtopic?: string | undefined;
    topic?: string | undefined;
}

export class ConversationGenerateExampleResponse implements IConversationGenerateExampleResponse {
    example?: string | undefined;

    constructor(data?: IConversationGenerateExampleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.example = _data["example"];
        }
    }

    static fromJS(data: any): ConversationGenerateExampleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationGenerateExampleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["example"] = this.example;
        return data;
    }
}

export interface IConversationGenerateExampleResponse {
    example?: string | undefined;
}

export class CreateAssessmentRequest implements ICreateAssessmentRequest {
    assessmentTypeID?: string | undefined;
    category?: string | undefined;
    description?: string | undefined;
    interactionType?: AssessmentInteractionType | undefined;
    skill?: string | undefined;
    topic?: string | undefined;
    totalQuestions?: number | undefined;
    totalTimeMinutes?: number | undefined;

    constructor(data?: ICreateAssessmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentTypeID = _data["assessmentTypeID"];
            this.category = _data["category"];
            this.description = _data["description"];
            this.interactionType = _data["interactionType"];
            this.skill = _data["skill"];
            this.topic = _data["topic"];
            this.totalQuestions = _data["totalQuestions"];
            this.totalTimeMinutes = _data["totalTimeMinutes"];
        }
    }

    static fromJS(data: any): CreateAssessmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssessmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentTypeID"] = this.assessmentTypeID;
        data["category"] = this.category;
        data["description"] = this.description;
        data["interactionType"] = this.interactionType;
        data["skill"] = this.skill;
        data["topic"] = this.topic;
        data["totalQuestions"] = this.totalQuestions;
        data["totalTimeMinutes"] = this.totalTimeMinutes;
        return data;
    }
}

export interface ICreateAssessmentRequest {
    assessmentTypeID?: string | undefined;
    category?: string | undefined;
    description?: string | undefined;
    interactionType?: AssessmentInteractionType | undefined;
    skill?: string | undefined;
    topic?: string | undefined;
    totalQuestions?: number | undefined;
    totalTimeMinutes?: number | undefined;
}

export class CreateAssessmentResponse implements ICreateAssessmentResponse {
    assessment?: Assessment | undefined;

    constructor(data?: ICreateAssessmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessment = _data["assessment"] ? Assessment.fromJS(_data["assessment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateAssessmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssessmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessment"] = this.assessment ? this.assessment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateAssessmentResponse {
    assessment?: Assessment | undefined;
}

export class CreateInterviewRequest implements ICreateInterviewRequest {
    category?: string | undefined;
    categoryType?: InterviewCategoryType | undefined;
    description?: string | undefined;
    interviewTypeID?: string | undefined;
    title?: string | undefined;
    totalQuestions?: number | undefined;
    totalTimeMinutes?: number | undefined;

    constructor(data?: ICreateInterviewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.categoryType = _data["categoryType"];
            this.description = _data["description"];
            this.interviewTypeID = _data["interviewTypeID"];
            this.title = _data["title"];
            this.totalQuestions = _data["totalQuestions"];
            this.totalTimeMinutes = _data["totalTimeMinutes"];
        }
    }

    static fromJS(data: any): CreateInterviewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInterviewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["categoryType"] = this.categoryType;
        data["description"] = this.description;
        data["interviewTypeID"] = this.interviewTypeID;
        data["title"] = this.title;
        data["totalQuestions"] = this.totalQuestions;
        data["totalTimeMinutes"] = this.totalTimeMinutes;
        return data;
    }
}

export interface ICreateInterviewRequest {
    category?: string | undefined;
    categoryType?: InterviewCategoryType | undefined;
    description?: string | undefined;
    interviewTypeID?: string | undefined;
    title?: string | undefined;
    totalQuestions?: number | undefined;
    totalTimeMinutes?: number | undefined;
}

export class CreateInterviewResponse implements ICreateInterviewResponse {
    interview?: Interview | undefined;

    constructor(data?: ICreateInterviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interview = _data["interview"] ? Interview.fromJS(_data["interview"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateInterviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInterviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interview"] = this.interview ? this.interview.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateInterviewResponse {
    interview?: Interview | undefined;
}

export class DescribeResponse implements IDescribeResponse {
    output?: string | undefined;

    constructor(data?: IDescribeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.output = _data["output"];
        }
    }

    static fromJS(data: any): DescribeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DescribeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        return data;
    }
}

export interface IDescribeResponse {
    output?: string | undefined;
}

export class ErrorDto implements IErrorDto {
    message?: string | undefined;

    constructor(data?: IErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IErrorDto {
    message?: string | undefined;
}

export enum FieldsToUpdate {
    Profile = "profile",
    Education = "education",
    Experiences = "experiences",
    Projects = "projects",
    Job_preference = "job_preference",
    Certificates = "certificates",
}

export class GenerateGeneralInterviewRequest implements IGenerateGeneralInterviewRequest {
    company?: string | undefined;
    description?: string | undefined;
    files?: string[] | undefined;
    title?: string | undefined;

    constructor(data?: IGenerateGeneralInterviewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"];
            this.description = _data["description"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(item);
            }
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): GenerateGeneralInterviewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateGeneralInterviewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["description"] = this.description;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item);
        }
        data["title"] = this.title;
        return data;
    }
}

export interface IGenerateGeneralInterviewRequest {
    company?: string | undefined;
    description?: string | undefined;
    files?: string[] | undefined;
    title?: string | undefined;
}

export class GenerateInterviewRequest implements IGenerateInterviewRequest {
    categories?: InterviewCategory[] | undefined;
    description?: string | undefined;
    files?: string[] | undefined;
    title?: string | undefined;

    constructor(data?: IGenerateInterviewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(InterviewCategory.fromJS(item));
            }
            this.description = _data["description"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(item);
            }
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): GenerateInterviewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateInterviewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["description"] = this.description;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item);
        }
        data["title"] = this.title;
        return data;
    }
}

export interface IGenerateInterviewRequest {
    categories?: InterviewCategory[] | undefined;
    description?: string | undefined;
    files?: string[] | undefined;
    title?: string | undefined;
}

export class GenerateJobInterviewRequest implements IGenerateJobInterviewRequest {
    categories?: InterviewCategory[] | undefined;
    description?: string | undefined;
    files?: string[] | undefined;
    title?: string | undefined;

    constructor(data?: IGenerateJobInterviewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(InterviewCategory.fromJS(item));
            }
            this.description = _data["description"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(item);
            }
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): GenerateJobInterviewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateJobInterviewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["description"] = this.description;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item);
        }
        data["title"] = this.title;
        return data;
    }
}

export interface IGenerateJobInterviewRequest {
    categories?: InterviewCategory[] | undefined;
    description?: string | undefined;
    files?: string[] | undefined;
    title?: string | undefined;
}

export class GenerateJobInterviewTypesByFilesRequest implements IGenerateJobInterviewTypesByFilesRequest {
    files?: string[] | undefined;

    constructor(data?: IGenerateJobInterviewTypesByFilesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(item);
            }
        }
    }

    static fromJS(data: any): GenerateJobInterviewTypesByFilesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateJobInterviewTypesByFilesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item);
        }
        return data;
    }
}

export interface IGenerateJobInterviewTypesByFilesRequest {
    files?: string[] | undefined;
}

export class GetActivityGraphResponse implements IGetActivityGraphResponse {
    dataPoints?: ActivityGraphDataPoint[] | undefined;

    constructor(data?: IGetActivityGraphResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dataPoints"])) {
                this.dataPoints = [] as any;
                for (let item of _data["dataPoints"])
                    this.dataPoints!.push(ActivityGraphDataPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetActivityGraphResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityGraphResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataPoints)) {
            data["dataPoints"] = [];
            for (let item of this.dataPoints)
                data["dataPoints"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetActivityGraphResponse {
    dataPoints?: ActivityGraphDataPoint[] | undefined;
}

export class GetAllInterviewActivitiesResponse implements IGetAllInterviewActivitiesResponse {

    [key: string]: GetInterviewActivitiesResponse | any;

    constructor(data?: IGetAllInterviewActivitiesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): GetAllInterviewActivitiesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllInterviewActivitiesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IGetAllInterviewActivitiesResponse {

    [key: string]: GetInterviewActivitiesResponse | any;
}

export class GetAssessmentActivitiesResponse implements IGetAssessmentActivitiesResponse {
    totalCompleted?: number | undefined;
    totalCreated?: number | undefined;
    totalFailed?: number | undefined;
    totalNotStarted?: number | undefined;
    totalStarted?: number | undefined;
    totalSuccessful?: number | undefined;
    totalUnfinished?: number | undefined;

    constructor(data?: IGetAssessmentActivitiesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCompleted = _data["totalCompleted"];
            this.totalCreated = _data["totalCreated"];
            this.totalFailed = _data["totalFailed"];
            this.totalNotStarted = _data["totalNotStarted"];
            this.totalStarted = _data["totalStarted"];
            this.totalSuccessful = _data["totalSuccessful"];
            this.totalUnfinished = _data["totalUnfinished"];
        }
    }

    static fromJS(data: any): GetAssessmentActivitiesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssessmentActivitiesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCompleted"] = this.totalCompleted;
        data["totalCreated"] = this.totalCreated;
        data["totalFailed"] = this.totalFailed;
        data["totalNotStarted"] = this.totalNotStarted;
        data["totalStarted"] = this.totalStarted;
        data["totalSuccessful"] = this.totalSuccessful;
        data["totalUnfinished"] = this.totalUnfinished;
        return data;
    }
}

export interface IGetAssessmentActivitiesResponse {
    totalCompleted?: number | undefined;
    totalCreated?: number | undefined;
    totalFailed?: number | undefined;
    totalNotStarted?: number | undefined;
    totalStarted?: number | undefined;
    totalSuccessful?: number | undefined;
    totalUnfinished?: number | undefined;
}

export class GetAssessmentsResponse implements IGetAssessmentsResponse {
    assessment?: Assessment | undefined;

    constructor(data?: IGetAssessmentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessment = _data["assessment"] ? Assessment.fromJS(_data["assessment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAssessmentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssessmentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessment"] = this.assessment ? this.assessment.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAssessmentsResponse {
    assessment?: Assessment | undefined;
}

export class GetBalanceResponse implements IGetBalanceResponse {
    balance?: number | undefined;
    balanceInAverageAssessment?: number | undefined;
    balanceInAverageCourse?: number | undefined;
    balanceInVoiceSeconds?: number | undefined;

    constructor(data?: IGetBalanceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.balance = _data["balance"];
            this.balanceInAverageAssessment = _data["balanceInAverageAssessment"];
            this.balanceInAverageCourse = _data["balanceInAverageCourse"];
            this.balanceInVoiceSeconds = _data["balanceInVoiceSeconds"];
        }
    }

    static fromJS(data: any): GetBalanceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBalanceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["balance"] = this.balance;
        data["balanceInAverageAssessment"] = this.balanceInAverageAssessment;
        data["balanceInAverageCourse"] = this.balanceInAverageCourse;
        data["balanceInVoiceSeconds"] = this.balanceInVoiceSeconds;
        return data;
    }
}

export interface IGetBalanceResponse {
    balance?: number | undefined;
    balanceInAverageAssessment?: number | undefined;
    balanceInAverageCourse?: number | undefined;
    balanceInVoiceSeconds?: number | undefined;
}

export class GetBillingSettingsResponse implements IGetBillingSettingsResponse {
    monthlyUsageLimit?: number | undefined;
    notificationEmail?: string | undefined;
    payerName?: string | undefined;
    payerPhoneNo?: string | undefined;

    constructor(data?: IGetBillingSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthlyUsageLimit = _data["monthlyUsageLimit"];
            this.notificationEmail = _data["notificationEmail"];
            this.payerName = _data["payerName"];
            this.payerPhoneNo = _data["payerPhoneNo"];
        }
    }

    static fromJS(data: any): GetBillingSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillingSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthlyUsageLimit"] = this.monthlyUsageLimit;
        data["notificationEmail"] = this.notificationEmail;
        data["payerName"] = this.payerName;
        data["payerPhoneNo"] = this.payerPhoneNo;
        return data;
    }
}

export interface IGetBillingSettingsResponse {
    monthlyUsageLimit?: number | undefined;
    notificationEmail?: string | undefined;
    payerName?: string | undefined;
    payerPhoneNo?: string | undefined;
}

export class GetCourseActivitiesResponse implements IGetCourseActivitiesResponse {
    totalCreated?: number | undefined;
    totalFinished?: number | undefined;
    totalNotStarted?: number | undefined;
    totalUnfinished?: number | undefined;

    constructor(data?: IGetCourseActivitiesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCreated = _data["totalCreated"];
            this.totalFinished = _data["totalFinished"];
            this.totalNotStarted = _data["totalNotStarted"];
            this.totalUnfinished = _data["totalUnfinished"];
        }
    }

    static fromJS(data: any): GetCourseActivitiesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCourseActivitiesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCreated"] = this.totalCreated;
        data["totalFinished"] = this.totalFinished;
        data["totalNotStarted"] = this.totalNotStarted;
        data["totalUnfinished"] = this.totalUnfinished;
        return data;
    }
}

export interface IGetCourseActivitiesResponse {
    totalCreated?: number | undefined;
    totalFinished?: number | undefined;
    totalNotStarted?: number | undefined;
    totalUnfinished?: number | undefined;
}

export class GetInterviewActivitiesResponse implements IGetInterviewActivitiesResponse {
    totalCompleted?: number | undefined;
    totalCreated?: number | undefined;
    totalFailed?: number | undefined;
    totalNotStarted?: number | undefined;
    totalStarted?: number | undefined;
    totalSuccessful?: number | undefined;

    constructor(data?: IGetInterviewActivitiesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCompleted = _data["totalCompleted"];
            this.totalCreated = _data["totalCreated"];
            this.totalFailed = _data["totalFailed"];
            this.totalNotStarted = _data["totalNotStarted"];
            this.totalStarted = _data["totalStarted"];
            this.totalSuccessful = _data["totalSuccessful"];
        }
    }

    static fromJS(data: any): GetInterviewActivitiesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInterviewActivitiesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCompleted"] = this.totalCompleted;
        data["totalCreated"] = this.totalCreated;
        data["totalFailed"] = this.totalFailed;
        data["totalNotStarted"] = this.totalNotStarted;
        data["totalStarted"] = this.totalStarted;
        data["totalSuccessful"] = this.totalSuccessful;
        return data;
    }
}

export interface IGetInterviewActivitiesResponse {
    totalCompleted?: number | undefined;
    totalCreated?: number | undefined;
    totalFailed?: number | undefined;
    totalNotStarted?: number | undefined;
    totalStarted?: number | undefined;
    totalSuccessful?: number | undefined;
}

export class GetInterviewsResponse implements IGetInterviewsResponse {
    interview?: Interview | undefined;

    constructor(data?: IGetInterviewsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interview = _data["interview"] ? Interview.fromJS(_data["interview"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetInterviewsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInterviewsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interview"] = this.interview ? this.interview.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetInterviewsResponse {
    interview?: Interview | undefined;
}

export class GetListOfInterviewCategoriesType implements IGetListOfInterviewCategoriesType {
    categoriesType?: InterviewCategoryType[] | undefined;

    constructor(data?: IGetListOfInterviewCategoriesType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categoriesType"])) {
                this.categoriesType = [] as any;
                for (let item of _data["categoriesType"])
                    this.categoriesType!.push(item);
            }
        }
    }

    static fromJS(data: any): GetListOfInterviewCategoriesType {
        data = typeof data === 'object' ? data : {};
        let result = new GetListOfInterviewCategoriesType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categoriesType)) {
            data["categoriesType"] = [];
            for (let item of this.categoriesType)
                data["categoriesType"].push(item);
        }
        return data;
    }
}

export interface IGetListOfInterviewCategoriesType {
    categoriesType?: InterviewCategoryType[] | undefined;
}

export class GetMeResponse implements IGetMeResponse {
    user?: User | undefined;

    constructor(data?: IGetMeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMeResponse {
    user?: User | undefined;
}

export class GetSkillScoreGraphResponse implements IGetSkillScoreGraphResponse {
    datapoints?: SkillScoreGraphDataPoint[] | undefined;

    constructor(data?: IGetSkillScoreGraphResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["datapoints"])) {
                this.datapoints = [] as any;
                for (let item of _data["datapoints"])
                    this.datapoints!.push(SkillScoreGraphDataPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSkillScoreGraphResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSkillScoreGraphResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datapoints)) {
            data["datapoints"] = [];
            for (let item of this.datapoints)
                data["datapoints"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSkillScoreGraphResponse {
    datapoints?: SkillScoreGraphDataPoint[] | undefined;
}

export class GetSuggestionResponse implements IGetSuggestionResponse {
    suggestions?: Suggestion[] | undefined;

    constructor(data?: IGetSuggestionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["suggestions"])) {
                this.suggestions = [] as any;
                for (let item of _data["suggestions"])
                    this.suggestions!.push(Suggestion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSuggestionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSuggestionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.suggestions)) {
            data["suggestions"] = [];
            for (let item of this.suggestions)
                data["suggestions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSuggestionResponse {
    suggestions?: Suggestion[] | undefined;
}

export class GetUserFilesListResponse implements IGetUserFilesListResponse {
    files?: File[] | undefined;

    constructor(data?: IGetUserFilesListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(File.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserFilesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserFilesListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserFilesListResponse {
    files?: File[] | undefined;
}

export class InterviewCategory implements IInterviewCategory {
    category?: string | undefined;
    company?: string | undefined;
    description?: string | undefined;

    constructor(data?: IInterviewCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.company = _data["company"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): InterviewCategory {
        data = typeof data === 'object' ? data : {};
        let result = new InterviewCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["company"] = this.company;
        data["description"] = this.description;
        return data;
    }
}

export interface IInterviewCategory {
    category?: string | undefined;
    company?: string | undefined;
    description?: string | undefined;
}

export class JobsResponse implements IJobsResponse {
    jobs?: Job[] | undefined;

    constructor(data?: IJobsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["jobs"])) {
                this.jobs = [] as any;
                for (let item of _data["jobs"])
                    this.jobs!.push(Job.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JobsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new JobsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.jobs)) {
            data["jobs"] = [];
            for (let item of this.jobs)
                data["jobs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJobsResponse {
    jobs?: Job[] | undefined;
}

export class ListAssessmentTypesResponse implements IListAssessmentTypesResponse {
    assessment_types?: AssessmentType[] | undefined;

    constructor(data?: IListAssessmentTypesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assessment_types"])) {
                this.assessment_types = [] as any;
                for (let item of _data["assessment_types"])
                    this.assessment_types!.push(AssessmentType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListAssessmentTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListAssessmentTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assessment_types)) {
            data["assessment_types"] = [];
            for (let item of this.assessment_types)
                data["assessment_types"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListAssessmentTypesResponse {
    assessment_types?: AssessmentType[] | undefined;
}

export class ListAssessmentsResponse implements IListAssessmentsResponse {
    assessments?: Assessment[] | undefined;

    constructor(data?: IListAssessmentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assessments"])) {
                this.assessments = [] as any;
                for (let item of _data["assessments"])
                    this.assessments!.push(Assessment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListAssessmentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListAssessmentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assessments)) {
            data["assessments"] = [];
            for (let item of this.assessments)
                data["assessments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListAssessmentsResponse {
    assessments?: Assessment[] | undefined;
}

export class ListInterviewTypesResponse implements IListInterviewTypesResponse {
    interview_types?: InterviewType[] | undefined;

    constructor(data?: IListInterviewTypesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["interview_types"])) {
                this.interview_types = [] as any;
                for (let item of _data["interview_types"])
                    this.interview_types!.push(InterviewType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListInterviewTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListInterviewTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.interview_types)) {
            data["interview_types"] = [];
            for (let item of this.interview_types)
                data["interview_types"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListInterviewTypesResponse {
    interview_types?: InterviewType[] | undefined;
}

export class ListInterviewsResponse implements IListInterviewsResponse {
    interviews?: Interview[] | undefined;

    constructor(data?: IListInterviewsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["interviews"])) {
                this.interviews = [] as any;
                for (let item of _data["interviews"])
                    this.interviews!.push(Interview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListInterviewsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListInterviewsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.interviews)) {
            data["interviews"] = [];
            for (let item of this.interviews)
                data["interviews"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListInterviewsResponse {
    interviews?: Interview[] | undefined;
}

export class ListRunningCoursesResponse implements IListRunningCoursesResponse {
    courses?: TrainingCourse[] | undefined;

    constructor(data?: IListRunningCoursesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["courses"])) {
                this.courses = [] as any;
                for (let item of _data["courses"])
                    this.courses!.push(TrainingCourse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListRunningCoursesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListRunningCoursesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.courses)) {
            data["courses"] = [];
            for (let item of this.courses)
                data["courses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListRunningCoursesResponse {
    courses?: TrainingCourse[] | undefined;
}

export class ListTrainingCoursesResponse implements IListTrainingCoursesResponse {
    courses?: UserTrainingCourse[] | undefined;

    constructor(data?: IListTrainingCoursesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["courses"])) {
                this.courses = [] as any;
                for (let item of _data["courses"])
                    this.courses!.push(UserTrainingCourse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListTrainingCoursesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListTrainingCoursesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.courses)) {
            data["courses"] = [];
            for (let item of this.courses)
                data["courses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListTrainingCoursesResponse {
    courses?: UserTrainingCourse[] | undefined;
}

export class ListTransactionsResponse implements IListTransactionsResponse {
    transactions?: Transaction[] | undefined;

    constructor(data?: IListTransactionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions!.push(Transaction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListTransactionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListTransactionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListTransactionsResponse {
    transactions?: Transaction[] | undefined;
}

export class LoginByResumeResponse implements ILoginByResumeResponse {
    email?: string | undefined;
    shouldLogin?: boolean | undefined;
    token?: string | undefined;

    constructor(data?: ILoginByResumeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.shouldLogin = _data["shouldLogin"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): LoginByResumeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginByResumeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["shouldLogin"] = this.shouldLogin;
        data["token"] = this.token;
        return data;
    }
}

export interface ILoginByResumeResponse {
    email?: string | undefined;
    shouldLogin?: boolean | undefined;
    token?: string | undefined;
}

export class QuestionRequest implements IQuestionRequest {
    inputText?: string | undefined;

    constructor(data?: IQuestionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputText = _data["inputText"];
        }
    }

    static fromJS(data: any): QuestionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputText"] = this.inputText;
        return data;
    }
}

export interface IQuestionRequest {
    inputText?: string | undefined;
}

export class RequestInterviewRequest implements IRequestInterviewRequest {
    description?: string | undefined;

    constructor(data?: IRequestInterviewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): RequestInterviewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequestInterviewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data;
    }
}

export interface IRequestInterviewRequest {
    description?: string | undefined;
}

export class RequestInterviewResponse implements IRequestInterviewResponse {
    categories?: InterviewCategory[] | undefined;

    constructor(data?: IRequestInterviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(InterviewCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequestInterviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RequestInterviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRequestInterviewResponse {
    categories?: InterviewCategory[] | undefined;
}

export class RequestMessage implements IRequestMessage {
    subscribeToTrainingConversation?: SubscribeToTrainingConversation | undefined;

    constructor(data?: IRequestMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscribeToTrainingConversation = _data["subscribeToTrainingConversation"] ? SubscribeToTrainingConversation.fromJS(_data["subscribeToTrainingConversation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestMessage {
        data = typeof data === 'object' ? data : {};
        let result = new RequestMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscribeToTrainingConversation"] = this.subscribeToTrainingConversation ? this.subscribeToTrainingConversation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRequestMessage {
    subscribeToTrainingConversation?: SubscribeToTrainingConversation | undefined;
}

export class RespondToAssessmentTextRequest implements IRespondToAssessmentTextRequest {
    response?: string | undefined;

    constructor(data?: IRespondToAssessmentTextRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.response = _data["response"];
        }
    }

    static fromJS(data: any): RespondToAssessmentTextRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RespondToAssessmentTextRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["response"] = this.response;
        return data;
    }
}

export interface IRespondToAssessmentTextRequest {
    response?: string | undefined;
}

export class RespondToInterviewTextRequest implements IRespondToInterviewTextRequest {
    response?: string | undefined;

    constructor(data?: IRespondToInterviewTextRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.response = _data["response"];
        }
    }

    static fromJS(data: any): RespondToInterviewTextRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RespondToInterviewTextRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["response"] = this.response;
        return data;
    }
}

export interface IRespondToInterviewTextRequest {
    response?: string | undefined;
}

export class ResponseMessage implements IResponseMessage {
    error?: ErrorDto | undefined;
    trainingConversationGenerationFinished?: TrainingConversationGenerationFinished | undefined;
    trainingMessage?: TrainingMessage | undefined;

    constructor(data?: IResponseMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : <any>undefined;
            this.trainingConversationGenerationFinished = _data["trainingConversationGenerationFinished"] ? TrainingConversationGenerationFinished.fromJS(_data["trainingConversationGenerationFinished"]) : <any>undefined;
            this.trainingMessage = _data["trainingMessage"] ? TrainingMessage.fromJS(_data["trainingMessage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["trainingConversationGenerationFinished"] = this.trainingConversationGenerationFinished ? this.trainingConversationGenerationFinished.toJSON() : <any>undefined;
        data["trainingMessage"] = this.trainingMessage ? this.trainingMessage.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseMessage {
    error?: ErrorDto | undefined;
    trainingConversationGenerationFinished?: TrainingConversationGenerationFinished | undefined;
    trainingMessage?: TrainingMessage | undefined;
}

export class SignUpEmailRequest implements ISignUpEmailRequest {
    email?: string | undefined;

    constructor(data?: ISignUpEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SignUpEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface ISignUpEmailRequest {
    email?: string | undefined;
}

export class SignUpPasswordRequest implements ISignUpPasswordRequest {
    password_hash?: string | undefined;
    token?: string | undefined;

    constructor(data?: ISignUpPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password_hash = _data["password_hash"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): SignUpPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password_hash"] = this.password_hash;
        data["token"] = this.token;
        return data;
    }
}

export interface ISignUpPasswordRequest {
    password_hash?: string | undefined;
    token?: string | undefined;
}

export class SkillBasedOnDescriptionRequest implements ISkillBasedOnDescriptionRequest {
    description?: string | undefined;
    gap?: boolean | undefined;

    constructor(data?: ISkillBasedOnDescriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.gap = _data["gap"];
        }
    }

    static fromJS(data: any): SkillBasedOnDescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkillBasedOnDescriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["gap"] = this.gap;
        return data;
    }
}

export interface ISkillBasedOnDescriptionRequest {
    description?: string | undefined;
    gap?: boolean | undefined;
}

export class SkillBasedOnDescriptionResponse implements ISkillBasedOnDescriptionResponse {
    suggestedSkills?: string[] | undefined;

    constructor(data?: ISkillBasedOnDescriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["suggestedSkills"])) {
                this.suggestedSkills = [] as any;
                for (let item of _data["suggestedSkills"])
                    this.suggestedSkills!.push(item);
            }
        }
    }

    static fromJS(data: any): SkillBasedOnDescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SkillBasedOnDescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.suggestedSkills)) {
            data["suggestedSkills"] = [];
            for (let item of this.suggestedSkills)
                data["suggestedSkills"].push(item);
        }
        return data;
    }
}

export interface ISkillBasedOnDescriptionResponse {
    suggestedSkills?: string[] | undefined;
}

export class SkillScoreGraphDataPoint implements ISkillScoreGraphDataPoint {
    date?: string | undefined;
    score?: number | undefined;
    skill?: string | undefined;

    constructor(data?: ISkillScoreGraphDataPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.score = _data["score"];
            this.skill = _data["skill"];
        }
    }

    static fromJS(data: any): SkillScoreGraphDataPoint {
        data = typeof data === 'object' ? data : {};
        let result = new SkillScoreGraphDataPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["score"] = this.score;
        data["skill"] = this.skill;
        return data;
    }
}

export interface ISkillScoreGraphDataPoint {
    date?: string | undefined;
    score?: number | undefined;
    skill?: string | undefined;
}

export class SocialPostRequest implements ISocialPostRequest {
    inputText?: string | undefined;

    constructor(data?: ISocialPostRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputText = _data["inputText"];
        }
    }

    static fromJS(data: any): SocialPostRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SocialPostRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputText"] = this.inputText;
        return data;
    }
}

export interface ISocialPostRequest {
    inputText?: string | undefined;
}

export class StartTrainingCourseRequest implements IStartTrainingCourseRequest {
    category?: string | undefined;
    description?: string | undefined;
    skill?: string | undefined;
    topic?: string | undefined;
    totalQuestions?: number | undefined;

    constructor(data?: IStartTrainingCourseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.description = _data["description"];
            this.skill = _data["skill"];
            this.topic = _data["topic"];
            this.totalQuestions = _data["totalQuestions"];
        }
    }

    static fromJS(data: any): StartTrainingCourseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StartTrainingCourseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["description"] = this.description;
        data["skill"] = this.skill;
        data["topic"] = this.topic;
        data["totalQuestions"] = this.totalQuestions;
        return data;
    }
}

export interface IStartTrainingCourseRequest {
    category?: string | undefined;
    description?: string | undefined;
    skill?: string | undefined;
    topic?: string | undefined;
    totalQuestions?: number | undefined;
}

export class StartTrainingCourseResponse implements IStartTrainingCourseResponse {
    course?: TrainingCourse | undefined;

    constructor(data?: IStartTrainingCourseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.course = _data["course"] ? TrainingCourse.fromJS(_data["course"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StartTrainingCourseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StartTrainingCourseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["course"] = this.course ? this.course.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStartTrainingCourseResponse {
    course?: TrainingCourse | undefined;
}

export class SubscribeToTrainingConversation implements ISubscribeToTrainingConversation {
    courseID?: number | undefined;
    subtopic?: string | undefined;
    topic?: string | undefined;

    constructor(data?: ISubscribeToTrainingConversation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseID = _data["courseID"];
            this.subtopic = _data["subtopic"];
            this.topic = _data["topic"];
        }
    }

    static fromJS(data: any): SubscribeToTrainingConversation {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribeToTrainingConversation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseID"] = this.courseID;
        data["subtopic"] = this.subtopic;
        data["topic"] = this.topic;
        return data;
    }
}

export interface ISubscribeToTrainingConversation {
    courseID?: number | undefined;
    subtopic?: string | undefined;
    topic?: string | undefined;
}

export class SuggestNewCertificatesResponse implements ISuggestNewCertificatesResponse {
    suggestedCertificates?: string[] | undefined;

    constructor(data?: ISuggestNewCertificatesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["suggestedCertificates"])) {
                this.suggestedCertificates = [] as any;
                for (let item of _data["suggestedCertificates"])
                    this.suggestedCertificates!.push(item);
            }
        }
    }

    static fromJS(data: any): SuggestNewCertificatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestNewCertificatesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.suggestedCertificates)) {
            data["suggestedCertificates"] = [];
            for (let item of this.suggestedCertificates)
                data["suggestedCertificates"].push(item);
        }
        return data;
    }
}

export interface ISuggestNewCertificatesResponse {
    suggestedCertificates?: string[] | undefined;
}

export class SuggestNewSkillsResponse implements ISuggestNewSkillsResponse {
    suggestedSkills?: string[] | undefined;

    constructor(data?: ISuggestNewSkillsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["suggestedSkills"])) {
                this.suggestedSkills = [] as any;
                for (let item of _data["suggestedSkills"])
                    this.suggestedSkills!.push(item);
            }
        }
    }

    static fromJS(data: any): SuggestNewSkillsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestNewSkillsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.suggestedSkills)) {
            data["suggestedSkills"] = [];
            for (let item of this.suggestedSkills)
                data["suggestedSkills"].push(item);
        }
        return data;
    }
}

export interface ISuggestNewSkillsResponse {
    suggestedSkills?: string[] | undefined;
}

export class Suggestion implements ISuggestion {
    payload?: SuggestionPayload | undefined;
    suggestionType?: SuggestionType | undefined;

    constructor(data?: ISuggestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payload = _data["payload"] ? SuggestionPayload.fromJS(_data["payload"]) : <any>undefined;
            this.suggestionType = _data["suggestionType"];
        }
    }

    static fromJS(data: any): Suggestion {
        data = typeof data === 'object' ? data : {};
        let result = new Suggestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payload"] = this.payload ? this.payload.toJSON() : <any>undefined;
        data["suggestionType"] = this.suggestionType;
        return data;
    }
}

export interface ISuggestion {
    payload?: SuggestionPayload | undefined;
    suggestionType?: SuggestionType | undefined;
}

export class SuggestionPayload implements ISuggestionPayload {
    amount?: string | undefined;
    description?: string | undefined;
    id?: string | undefined;
    items?: string[] | undefined;
    title?: string | undefined;
    type?: string | undefined;
    url?: string | undefined;
    voiceURL?: string | undefined;

    constructor(data?: ISuggestionPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.id = _data["id"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
            this.title = _data["title"];
            this.type = _data["type"];
            this.url = _data["url"];
            this.voiceURL = _data["voiceURL"];
        }
    }

    static fromJS(data: any): SuggestionPayload {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["id"] = this.id;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        data["title"] = this.title;
        data["type"] = this.type;
        data["url"] = this.url;
        data["voiceURL"] = this.voiceURL;
        return data;
    }
}

export interface ISuggestionPayload {
    amount?: string | undefined;
    description?: string | undefined;
    id?: string | undefined;
    items?: string[] | undefined;
    title?: string | undefined;
    type?: string | undefined;
    url?: string | undefined;
    voiceURL?: string | undefined;
}

export enum SuggestionType {
    SendSocialPost = "SendSocialPost",
    RetakeAssessment = "RetakeAssessment",
    RetakeInterview = "RetakeInterview",
    Learn = "Learn",
    DailyTip = "DailyTip",
    IncreaseCredit = "IncreaseCredit",
    NewSkill = "NewSkill",
    GetCertificate = "GetCertificate",
}

export class TTSRequest implements ITTSRequest {
    inputText?: string | undefined;
    speechVoice?: SpeechVoice | undefined;

    constructor(data?: ITTSRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputText = _data["inputText"];
            this.speechVoice = _data["speechVoice"];
        }
    }

    static fromJS(data: any): TTSRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TTSRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputText"] = this.inputText;
        data["speechVoice"] = this.speechVoice;
        return data;
    }
}

export interface ITTSRequest {
    inputText?: string | undefined;
    speechVoice?: SpeechVoice | undefined;
}

export class TopUpRequest implements ITopUpRequest {
    amount?: string | undefined;
    currency?: string | undefined;
    network?: string | undefined;

    constructor(data?: ITopUpRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.network = _data["network"];
        }
    }

    static fromJS(data: any): TopUpRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TopUpRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["network"] = this.network;
        return data;
    }
}

export interface ITopUpRequest {
    amount?: string | undefined;
    currency?: string | undefined;
    network?: string | undefined;
}

export class TopUpResponse implements ITopUpResponse {
    address?: string | undefined;
    currency?: string | undefined;
    network?: string | undefined;
    topUpID?: number | undefined;
    url?: string | undefined;
    uuid?: string | undefined;
    wallet_uuid?: string | undefined;

    constructor(data?: ITopUpResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.currency = _data["currency"];
            this.network = _data["network"];
            this.topUpID = _data["topUpID"];
            this.url = _data["url"];
            this.uuid = _data["uuid"];
            this.wallet_uuid = _data["wallet_uuid"];
        }
    }

    static fromJS(data: any): TopUpResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TopUpResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["currency"] = this.currency;
        data["network"] = this.network;
        data["topUpID"] = this.topUpID;
        data["url"] = this.url;
        data["uuid"] = this.uuid;
        data["wallet_uuid"] = this.wallet_uuid;
        return data;
    }
}

export interface ITopUpResponse {
    address?: string | undefined;
    currency?: string | undefined;
    network?: string | undefined;
    topUpID?: number | undefined;
    url?: string | undefined;
    uuid?: string | undefined;
    wallet_uuid?: string | undefined;
}

export class TrainingConversationGenerationFinished implements ITrainingConversationGenerationFinished {
    finished?: boolean | undefined;

    constructor(data?: ITrainingConversationGenerationFinished) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.finished = _data["finished"];
        }
    }

    static fromJS(data: any): TrainingConversationGenerationFinished {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingConversationGenerationFinished();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finished"] = this.finished;
        return data;
    }
}

export interface ITrainingConversationGenerationFinished {
    finished?: boolean | undefined;
}

export class TrainingMessage implements ITrainingMessage {
    avatar?: string | undefined;
    avatar_id?: string | undefined;
    avatar_run_status?: TalkStatus | undefined;
    created_at?: number | undefined;
    id?: string | undefined;
    message?: string | undefined;
    new_message?: MessageStructure | undefined;
    role?: string | undefined;
    voiceFile?: string | undefined;
    voiceLengthSeconds?: number | undefined;

    constructor(data?: ITrainingMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avatar = _data["avatar"];
            this.avatar_id = _data["avatar_id"];
            this.avatar_run_status = _data["avatar_run_status"];
            this.created_at = _data["created_at"];
            this.id = _data["id"];
            this.message = _data["message"];
            this.new_message = _data["new_message"] ? MessageStructure.fromJS(_data["new_message"]) : <any>undefined;
            this.role = _data["role"];
            this.voiceFile = _data["voiceFile"];
            this.voiceLengthSeconds = _data["voiceLengthSeconds"];
        }
    }

    static fromJS(data: any): TrainingMessage {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avatar"] = this.avatar;
        data["avatar_id"] = this.avatar_id;
        data["avatar_run_status"] = this.avatar_run_status;
        data["created_at"] = this.created_at;
        data["id"] = this.id;
        data["message"] = this.message;
        data["new_message"] = this.new_message ? this.new_message.toJSON() : <any>undefined;
        data["role"] = this.role;
        data["voiceFile"] = this.voiceFile;
        data["voiceLengthSeconds"] = this.voiceLengthSeconds;
        return data;
    }
}

export interface ITrainingMessage {
    avatar?: string | undefined;
    avatar_id?: string | undefined;
    avatar_run_status?: TalkStatus | undefined;
    created_at?: number | undefined;
    id?: string | undefined;
    message?: string | undefined;
    new_message?: MessageStructure | undefined;
    role?: string | undefined;
    voiceFile?: string | undefined;
    voiceLengthSeconds?: number | undefined;
}

export class UpdateBillingSettingsRequest implements IUpdateBillingSettingsRequest {
    monthlyUsageLimit?: number | undefined;
    notificationEmail?: string | undefined;
    payerName?: string | undefined;
    payerPhoneNo?: string | undefined;

    constructor(data?: IUpdateBillingSettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthlyUsageLimit = _data["monthlyUsageLimit"];
            this.notificationEmail = _data["notificationEmail"];
            this.payerName = _data["payerName"];
            this.payerPhoneNo = _data["payerPhoneNo"];
        }
    }

    static fromJS(data: any): UpdateBillingSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBillingSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthlyUsageLimit"] = this.monthlyUsageLimit;
        data["notificationEmail"] = this.notificationEmail;
        data["payerName"] = this.payerName;
        data["payerPhoneNo"] = this.payerPhoneNo;
        return data;
    }
}

export interface IUpdateBillingSettingsRequest {
    monthlyUsageLimit?: number | undefined;
    notificationEmail?: string | undefined;
    payerName?: string | undefined;
    payerPhoneNo?: string | undefined;
}

export class UpdateMeRequest implements IUpdateMeRequest {
    certificates?: Certificate[] | undefined;
    education?: Education[] | undefined;
    experiences?: Experience[] | undefined;
    fieldsToUpdate?: FieldsToUpdate[] | undefined;
    jobPreference?: JobPreference | undefined;
    profile?: UserProfile | undefined;
    projects?: Project[] | undefined;

    constructor(data?: IUpdateMeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["certificates"])) {
                this.certificates = [] as any;
                for (let item of _data["certificates"])
                    this.certificates!.push(Certificate.fromJS(item));
            }
            if (Array.isArray(_data["education"])) {
                this.education = [] as any;
                for (let item of _data["education"])
                    this.education!.push(Education.fromJS(item));
            }
            if (Array.isArray(_data["experiences"])) {
                this.experiences = [] as any;
                for (let item of _data["experiences"])
                    this.experiences!.push(Experience.fromJS(item));
            }
            if (Array.isArray(_data["fieldsToUpdate"])) {
                this.fieldsToUpdate = [] as any;
                for (let item of _data["fieldsToUpdate"])
                    this.fieldsToUpdate!.push(item);
            }
            this.jobPreference = _data["jobPreference"] ? JobPreference.fromJS(_data["jobPreference"]) : <any>undefined;
            this.profile = _data["profile"] ? UserProfile.fromJS(_data["profile"]) : <any>undefined;
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(Project.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateMeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.certificates)) {
            data["certificates"] = [];
            for (let item of this.certificates)
                data["certificates"].push(item.toJSON());
        }
        if (Array.isArray(this.education)) {
            data["education"] = [];
            for (let item of this.education)
                data["education"].push(item.toJSON());
        }
        if (Array.isArray(this.experiences)) {
            data["experiences"] = [];
            for (let item of this.experiences)
                data["experiences"].push(item.toJSON());
        }
        if (Array.isArray(this.fieldsToUpdate)) {
            data["fieldsToUpdate"] = [];
            for (let item of this.fieldsToUpdate)
                data["fieldsToUpdate"].push(item);
        }
        data["jobPreference"] = this.jobPreference ? this.jobPreference.toJSON() : <any>undefined;
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateMeRequest {
    certificates?: Certificate[] | undefined;
    education?: Education[] | undefined;
    experiences?: Experience[] | undefined;
    fieldsToUpdate?: FieldsToUpdate[] | undefined;
    jobPreference?: JobPreference | undefined;
    profile?: UserProfile | undefined;
    projects?: Project[] | undefined;
}

export class GetFilesListResponse implements IGetFilesListResponse {
    files?: File[] | undefined;

    constructor(data?: IGetFilesListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(File.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFilesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilesListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFilesListResponse {
    files?: File[] | undefined;
}

export class UploadFileResponse implements IUploadFileResponse {
    fileId?: string | undefined;

    constructor(data?: IUploadFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): UploadFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IUploadFileResponse {
    fileId?: string | undefined;
}

export class UploadFileStreamResponse implements IUploadFileStreamResponse {
    url?: string | undefined;

    constructor(data?: IUploadFileStreamResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): UploadFileStreamResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileStreamResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IUploadFileStreamResponse {
    url?: string | undefined;
}

export class DeletedAt implements IDeletedAt {
    time?: string | undefined;
    /** Valid is true if Time is not NULL */
    valid?: boolean | undefined;

    constructor(data?: IDeletedAt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.time = _data["time"];
            this.valid = _data["valid"];
        }
    }

    static fromJS(data: any): DeletedAt {
        data = typeof data === 'object' ? data : {};
        let result = new DeletedAt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time;
        data["valid"] = this.valid;
        return data;
    }
}

export interface IDeletedAt {
    time?: string | undefined;
    /** Valid is true if Time is not NULL */
    valid?: boolean | undefined;
}

export enum BillingProduct {
    Assessment = "Assessment",
    Profile = "Profile",
    Interview = "Interview",
    Training_Course = "Training Course",
    Text_to_Speech = "Text to Speech",
    Speech_to_Text = "Speech to Text",
    Agent = "Agent",
    FreeCredit = "FreeCredit",
}

export class Assessment implements IAssessment {
    assessmentTypeID?: string | undefined;
    category?: string | undefined;
    conversation?: Conversation | undefined;
    createdAt?: string | undefined;
    description?: string | undefined;
    id?: number | undefined;
    interactionType?: AssessmentInteractionType | undefined;
    isCancelled?: boolean | undefined;
    isPaused?: boolean | undefined;
    report?: ReportStructure | undefined;
    reportMessage?: string | undefined;
    skill?: string | undefined;
    startTime?: string | undefined;
    topic?: string | undefined;
    totalPassedMinutes?: number | undefined;
    totalQuestions?: number | undefined;
    totalTimeMinutes?: number | undefined;
    updatedAt?: string | undefined;
    userId?: string | undefined;

    constructor(data?: IAssessment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentTypeID = _data["assessmentTypeID"];
            this.category = _data["category"];
            this.conversation = _data["conversation"] ? Conversation.fromJS(_data["conversation"]) : <any>undefined;
            this.createdAt = _data["createdAt"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.interactionType = _data["interactionType"];
            this.isCancelled = _data["isCancelled"];
            this.isPaused = _data["isPaused"];
            this.report = _data["report"] ? ReportStructure.fromJS(_data["report"]) : <any>undefined;
            this.reportMessage = _data["reportMessage"];
            this.skill = _data["skill"];
            this.startTime = _data["startTime"];
            this.topic = _data["topic"];
            this.totalPassedMinutes = _data["totalPassedMinutes"];
            this.totalQuestions = _data["totalQuestions"];
            this.totalTimeMinutes = _data["totalTimeMinutes"];
            this.updatedAt = _data["updatedAt"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): Assessment {
        data = typeof data === 'object' ? data : {};
        let result = new Assessment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentTypeID"] = this.assessmentTypeID;
        data["category"] = this.category;
        data["conversation"] = this.conversation ? this.conversation.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt;
        data["description"] = this.description;
        data["id"] = this.id;
        data["interactionType"] = this.interactionType;
        data["isCancelled"] = this.isCancelled;
        data["isPaused"] = this.isPaused;
        data["report"] = this.report ? this.report.toJSON() : <any>undefined;
        data["reportMessage"] = this.reportMessage;
        data["skill"] = this.skill;
        data["startTime"] = this.startTime;
        data["topic"] = this.topic;
        data["totalPassedMinutes"] = this.totalPassedMinutes;
        data["totalQuestions"] = this.totalQuestions;
        data["totalTimeMinutes"] = this.totalTimeMinutes;
        data["updatedAt"] = this.updatedAt;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAssessment {
    assessmentTypeID?: string | undefined;
    category?: string | undefined;
    conversation?: Conversation | undefined;
    createdAt?: string | undefined;
    description?: string | undefined;
    id?: number | undefined;
    interactionType?: AssessmentInteractionType | undefined;
    isCancelled?: boolean | undefined;
    isPaused?: boolean | undefined;
    report?: ReportStructure | undefined;
    reportMessage?: string | undefined;
    skill?: string | undefined;
    startTime?: string | undefined;
    topic?: string | undefined;
    totalPassedMinutes?: number | undefined;
    totalQuestions?: number | undefined;
    totalTimeMinutes?: number | undefined;
    updatedAt?: string | undefined;
    userId?: string | undefined;
}

export enum AssessmentInteractionType {
    Text = "text",
    Voice = "voice",
    Video = "video",
}

export class AssessmentType implements IAssessmentType {
    category?: string | undefined;
    description?: string | undefined;
    durationMinutes?: number | undefined;
    id?: string | undefined;
    skill?: string | undefined;
    title?: string | undefined;
    totalQuestions?: number | undefined;

    constructor(data?: IAssessmentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.description = _data["description"];
            this.durationMinutes = _data["durationMinutes"];
            this.id = _data["id"];
            this.skill = _data["skill"];
            this.title = _data["title"];
            this.totalQuestions = _data["totalQuestions"];
        }
    }

    static fromJS(data: any): AssessmentType {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["description"] = this.description;
        data["durationMinutes"] = this.durationMinutes;
        data["id"] = this.id;
        data["skill"] = this.skill;
        data["title"] = this.title;
        data["totalQuestions"] = this.totalQuestions;
        return data;
    }
}

export interface IAssessmentType {
    category?: string | undefined;
    description?: string | undefined;
    durationMinutes?: number | undefined;
    id?: string | undefined;
    skill?: string | undefined;
    title?: string | undefined;
    totalQuestions?: number | undefined;
}

export class Certificate implements ICertificate {
    courseName?: string | undefined;
    endMonth?: string | undefined;
    endYear?: string | undefined;
    instituteName?: string | undefined;
    logo?: string | undefined;
    startMonth?: string | undefined;
    startYear?: string | undefined;

    constructor(data?: ICertificate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseName = _data["courseName"];
            this.endMonth = _data["endMonth"];
            this.endYear = _data["endYear"];
            this.instituteName = _data["instituteName"];
            this.logo = _data["logo"];
            this.startMonth = _data["startMonth"];
            this.startYear = _data["startYear"];
        }
    }

    static fromJS(data: any): Certificate {
        data = typeof data === 'object' ? data : {};
        let result = new Certificate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseName"] = this.courseName;
        data["endMonth"] = this.endMonth;
        data["endYear"] = this.endYear;
        data["instituteName"] = this.instituteName;
        data["logo"] = this.logo;
        data["startMonth"] = this.startMonth;
        data["startYear"] = this.startYear;
        return data;
    }
}

export interface ICertificate {
    courseName?: string | undefined;
    endMonth?: string | undefined;
    endYear?: string | undefined;
    instituteName?: string | undefined;
    logo?: string | undefined;
    startMonth?: string | undefined;
    startYear?: string | undefined;
}

export class Conversation implements IConversation {
    messages?: Message[] | undefined;

    constructor(data?: IConversation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(Message.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Conversation {
        data = typeof data === 'object' ? data : {};
        let result = new Conversation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConversation {
    messages?: Message[] | undefined;
}

export class Education implements IEducation {
    degree?: string | undefined;
    description?: string | undefined;
    endMonth?: string | undefined;
    endYear?: string | undefined;
    field?: string | undefined;
    logo?: string | undefined;
    repetitive?: boolean | undefined;
    startMonth?: string | undefined;
    startYear?: string | undefined;
    university?: string | undefined;

    constructor(data?: IEducation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.degree = _data["degree"];
            this.description = _data["description"];
            this.endMonth = _data["endMonth"];
            this.endYear = _data["endYear"];
            this.field = _data["field"];
            this.logo = _data["logo"];
            this.repetitive = _data["repetitive"];
            this.startMonth = _data["startMonth"];
            this.startYear = _data["startYear"];
            this.university = _data["university"];
        }
    }

    static fromJS(data: any): Education {
        data = typeof data === 'object' ? data : {};
        let result = new Education();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["degree"] = this.degree;
        data["description"] = this.description;
        data["endMonth"] = this.endMonth;
        data["endYear"] = this.endYear;
        data["field"] = this.field;
        data["logo"] = this.logo;
        data["repetitive"] = this.repetitive;
        data["startMonth"] = this.startMonth;
        data["startYear"] = this.startYear;
        data["university"] = this.university;
        return data;
    }
}

export interface IEducation {
    degree?: string | undefined;
    description?: string | undefined;
    endMonth?: string | undefined;
    endYear?: string | undefined;
    field?: string | undefined;
    logo?: string | undefined;
    repetitive?: boolean | undefined;
    startMonth?: string | undefined;
    startYear?: string | undefined;
    university?: string | undefined;
}

export class Experience implements IExperience {
    companyName?: string | undefined;
    description?: string | undefined;
    endMonth?: string | undefined;
    endYear?: string | undefined;
    jobTitle?: string | undefined;
    location?: string | undefined;
    postcode?: string | undefined;
    repetitive?: boolean | undefined;
    startMonth?: string | undefined;
    startYear?: string | undefined;

    constructor(data?: IExperience) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.description = _data["description"];
            this.endMonth = _data["endMonth"];
            this.endYear = _data["endYear"];
            this.jobTitle = _data["jobTitle"];
            this.location = _data["location"];
            this.postcode = _data["postcode"];
            this.repetitive = _data["repetitive"];
            this.startMonth = _data["startMonth"];
            this.startYear = _data["startYear"];
        }
    }

    static fromJS(data: any): Experience {
        data = typeof data === 'object' ? data : {};
        let result = new Experience();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["description"] = this.description;
        data["endMonth"] = this.endMonth;
        data["endYear"] = this.endYear;
        data["jobTitle"] = this.jobTitle;
        data["location"] = this.location;
        data["postcode"] = this.postcode;
        data["repetitive"] = this.repetitive;
        data["startMonth"] = this.startMonth;
        data["startYear"] = this.startYear;
        return data;
    }
}

export interface IExperience {
    companyName?: string | undefined;
    description?: string | undefined;
    endMonth?: string | undefined;
    endYear?: string | undefined;
    jobTitle?: string | undefined;
    location?: string | undefined;
    postcode?: string | undefined;
    repetitive?: boolean | undefined;
    startMonth?: string | undefined;
    startYear?: string | undefined;
}

export class File implements IFile {
    contentType?: string | undefined;
    createdAt?: string | undefined;
    extension?: string | undefined;
    fileId?: string | undefined;
    id?: number | undefined;
    size?: number | undefined;
    source?: FileSource | undefined;
    updatedAt?: string | undefined;
    userId?: string | undefined;

    constructor(data?: IFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentType = _data["contentType"];
            this.createdAt = _data["createdAt"];
            this.extension = _data["extension"];
            this.fileId = _data["fileId"];
            this.id = _data["id"];
            this.size = _data["size"];
            this.source = _data["source"];
            this.updatedAt = _data["updatedAt"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): File {
        data = typeof data === 'object' ? data : {};
        let result = new File();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["createdAt"] = this.createdAt;
        data["extension"] = this.extension;
        data["fileId"] = this.fileId;
        data["id"] = this.id;
        data["size"] = this.size;
        data["source"] = this.source;
        data["updatedAt"] = this.updatedAt;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IFile {
    contentType?: string | undefined;
    createdAt?: string | undefined;
    extension?: string | undefined;
    fileId?: string | undefined;
    id?: number | undefined;
    size?: number | undefined;
    source?: FileSource | undefined;
    updatedAt?: string | undefined;
    userId?: string | undefined;
}

export enum FileSource {
    GENERATE_INTERVIEW = "GENERATE_INTERVIEW",
    GENERAL = "GENERAL",
}

export class Interview implements IInterview {
    category?: string | undefined;
    categoryType?: InterviewCategoryType | undefined;
    conversation?: Conversation | undefined;
    createdAt?: string | undefined;
    description?: string | undefined;
    id?: number | undefined;
    interviewTypeID?: string | undefined;
    isCancelled?: boolean | undefined;
    isPaused?: boolean | undefined;
    report?: ReportStructure | undefined;
    reportMessage?: string | undefined;
    startTime?: string | undefined;
    title?: string | undefined;
    totalPassedMinutes?: number | undefined;
    totalQuestions?: number | undefined;
    totalTimeMinutes?: number | undefined;
    updatedAt?: string | undefined;
    userId?: string | undefined;

    constructor(data?: IInterview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.categoryType = _data["categoryType"];
            this.conversation = _data["conversation"] ? Conversation.fromJS(_data["conversation"]) : <any>undefined;
            this.createdAt = _data["createdAt"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.interviewTypeID = _data["interviewTypeID"];
            this.isCancelled = _data["isCancelled"];
            this.isPaused = _data["isPaused"];
            this.report = _data["report"] ? ReportStructure.fromJS(_data["report"]) : <any>undefined;
            this.reportMessage = _data["reportMessage"];
            this.startTime = _data["startTime"];
            this.title = _data["title"];
            this.totalPassedMinutes = _data["totalPassedMinutes"];
            this.totalQuestions = _data["totalQuestions"];
            this.totalTimeMinutes = _data["totalTimeMinutes"];
            this.updatedAt = _data["updatedAt"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): Interview {
        data = typeof data === 'object' ? data : {};
        let result = new Interview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["categoryType"] = this.categoryType;
        data["conversation"] = this.conversation ? this.conversation.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt;
        data["description"] = this.description;
        data["id"] = this.id;
        data["interviewTypeID"] = this.interviewTypeID;
        data["isCancelled"] = this.isCancelled;
        data["isPaused"] = this.isPaused;
        data["report"] = this.report ? this.report.toJSON() : <any>undefined;
        data["reportMessage"] = this.reportMessage;
        data["startTime"] = this.startTime;
        data["title"] = this.title;
        data["totalPassedMinutes"] = this.totalPassedMinutes;
        data["totalQuestions"] = this.totalQuestions;
        data["totalTimeMinutes"] = this.totalTimeMinutes;
        data["updatedAt"] = this.updatedAt;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IInterview {
    category?: string | undefined;
    categoryType?: InterviewCategoryType | undefined;
    conversation?: Conversation | undefined;
    createdAt?: string | undefined;
    description?: string | undefined;
    id?: number | undefined;
    interviewTypeID?: string | undefined;
    isCancelled?: boolean | undefined;
    isPaused?: boolean | undefined;
    report?: ReportStructure | undefined;
    reportMessage?: string | undefined;
    startTime?: string | undefined;
    title?: string | undefined;
    totalPassedMinutes?: number | undefined;
    totalQuestions?: number | undefined;
    totalTimeMinutes?: number | undefined;
    updatedAt?: string | undefined;
    userId?: string | undefined;
}

export enum InterviewCategoryType {
    GENERAL = "GENERAL",
    JOB = "JOB",
}

export class InterviewType implements IInterviewType {
    category?: string | undefined;
    categoryType?: InterviewCategoryType | undefined;
    company?: string | undefined;
    description?: string | undefined;
    durationMinutes?: number | undefined;
    id?: string | undefined;
    title?: string | undefined;
    totalQuestions?: number | undefined;

    constructor(data?: IInterviewType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.categoryType = _data["categoryType"];
            this.company = _data["company"];
            this.description = _data["description"];
            this.durationMinutes = _data["durationMinutes"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.totalQuestions = _data["totalQuestions"];
        }
    }

    static fromJS(data: any): InterviewType {
        data = typeof data === 'object' ? data : {};
        let result = new InterviewType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["categoryType"] = this.categoryType;
        data["company"] = this.company;
        data["description"] = this.description;
        data["durationMinutes"] = this.durationMinutes;
        data["id"] = this.id;
        data["title"] = this.title;
        data["totalQuestions"] = this.totalQuestions;
        return data;
    }
}

export interface IInterviewType {
    category?: string | undefined;
    categoryType?: InterviewCategoryType | undefined;
    company?: string | undefined;
    description?: string | undefined;
    durationMinutes?: number | undefined;
    id?: string | undefined;
    title?: string | undefined;
    totalQuestions?: number | undefined;
}

export class Job implements IJob {
    createdAt?: string | undefined;
    failureReason?: string | undefined;
    id?: number | undefined;
    jobType?: JobType | undefined;
    maxRetries?: number | undefined;
    retryCount?: number | undefined;
    status?: Status | undefined;
    updatedAt?: string | undefined;
    userID?: string | undefined;

    constructor(data?: IJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdAt = _data["createdAt"];
            this.failureReason = _data["failureReason"];
            this.id = _data["id"];
            this.jobType = _data["jobType"];
            this.maxRetries = _data["maxRetries"];
            this.retryCount = _data["retryCount"];
            this.status = _data["status"];
            this.updatedAt = _data["updatedAt"];
            this.userID = _data["userID"];
        }
    }

    static fromJS(data: any): Job {
        data = typeof data === 'object' ? data : {};
        let result = new Job();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdAt"] = this.createdAt;
        data["failureReason"] = this.failureReason;
        data["id"] = this.id;
        data["jobType"] = this.jobType;
        data["maxRetries"] = this.maxRetries;
        data["retryCount"] = this.retryCount;
        data["status"] = this.status;
        data["updatedAt"] = this.updatedAt;
        data["userID"] = this.userID;
        return data;
    }
}

export interface IJob {
    createdAt?: string | undefined;
    failureReason?: string | undefined;
    id?: number | undefined;
    jobType?: JobType | undefined;
    maxRetries?: number | undefined;
    retryCount?: number | undefined;
    status?: Status | undefined;
    updatedAt?: string | undefined;
    userID?: string | undefined;
}

export class JobPreference implements IJobPreference {
    authorized?: string | undefined;
    commitment?: string | undefined;
    countries?: string[] | undefined;
    englishProficiency?: string | undefined;
    sponsorship?: string | undefined;
    startingTime?: string | undefined;

    constructor(data?: IJobPreference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorized = _data["authorized"];
            this.commitment = _data["commitment"];
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(item);
            }
            this.englishProficiency = _data["englishProficiency"];
            this.sponsorship = _data["sponsorship"];
            this.startingTime = _data["startingTime"];
        }
    }

    static fromJS(data: any): JobPreference {
        data = typeof data === 'object' ? data : {};
        let result = new JobPreference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorized"] = this.authorized;
        data["commitment"] = this.commitment;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item);
        }
        data["englishProficiency"] = this.englishProficiency;
        data["sponsorship"] = this.sponsorship;
        data["startingTime"] = this.startingTime;
        return data;
    }
}

export interface IJobPreference {
    authorized?: string | undefined;
    commitment?: string | undefined;
    countries?: string[] | undefined;
    englishProficiency?: string | undefined;
    sponsorship?: string | undefined;
    startingTime?: string | undefined;
}

export enum JobType {
    UpdateAssessmentTypes = "UpdateAssessmentTypes",
    UpdateTrainingCourses = "UpdateTrainingCourses",
    SendDataToCMSManager = "SendDataToCMSManager",
}

export class Message implements IMessage {
    avatar?: string | undefined;
    avatar_id?: string | undefined;
    avatar_run_status?: TalkStatus | undefined;
    created_at?: number | undefined;
    id?: string | undefined;
    message?: string | undefined;
    new_message?: MessageStructure | undefined;
    role?: string | undefined;
    voiceFile?: string | undefined;
    voiceLengthSeconds?: number | undefined;

    constructor(data?: IMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avatar = _data["avatar"];
            this.avatar_id = _data["avatar_id"];
            this.avatar_run_status = _data["avatar_run_status"];
            this.created_at = _data["created_at"];
            this.id = _data["id"];
            this.message = _data["message"];
            this.new_message = _data["new_message"] ? MessageStructure.fromJS(_data["new_message"]) : <any>undefined;
            this.role = _data["role"];
            this.voiceFile = _data["voiceFile"];
            this.voiceLengthSeconds = _data["voiceLengthSeconds"];
        }
    }

    static fromJS(data: any): Message {
        data = typeof data === 'object' ? data : {};
        let result = new Message();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avatar"] = this.avatar;
        data["avatar_id"] = this.avatar_id;
        data["avatar_run_status"] = this.avatar_run_status;
        data["created_at"] = this.created_at;
        data["id"] = this.id;
        data["message"] = this.message;
        data["new_message"] = this.new_message ? this.new_message.toJSON() : <any>undefined;
        data["role"] = this.role;
        data["voiceFile"] = this.voiceFile;
        data["voiceLengthSeconds"] = this.voiceLengthSeconds;
        return data;
    }
}

export interface IMessage {
    avatar?: string | undefined;
    avatar_id?: string | undefined;
    avatar_run_status?: TalkStatus | undefined;
    created_at?: number | undefined;
    id?: string | undefined;
    message?: string | undefined;
    new_message?: MessageStructure | undefined;
    role?: string | undefined;
    voiceFile?: string | undefined;
    voiceLengthSeconds?: number | undefined;
}

export class MessageStructure implements IMessageStructure {
    choices?: string[] | undefined;
    question?: string | undefined;
    question_number?: number | undefined;
    question_type?: QuestionType | undefined;
    total_question_count?: number | undefined;

    constructor(data?: IMessageStructure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(item);
            }
            this.question = _data["question"];
            this.question_number = _data["question_number"];
            this.question_type = _data["question_type"];
            this.total_question_count = _data["total_question_count"];
        }
    }

    static fromJS(data: any): MessageStructure {
        data = typeof data === 'object' ? data : {};
        let result = new MessageStructure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item);
        }
        data["question"] = this.question;
        data["question_number"] = this.question_number;
        data["question_type"] = this.question_type;
        data["total_question_count"] = this.total_question_count;
        return data;
    }
}

export interface IMessageStructure {
    choices?: string[] | undefined;
    question?: string | undefined;
    question_number?: number | undefined;
    question_type?: QuestionType | undefined;
    total_question_count?: number | undefined;
}

export class Project implements IProject {
    description?: string | undefined;
    endMonth?: string | undefined;
    endYear?: string | undefined;
    image1?: string | undefined;
    image2?: string | undefined;
    image3?: string | undefined;
    logo?: string | undefined;
    projectName?: string | undefined;
    projectUrl?: string | undefined;
    repetitive?: boolean | undefined;
    role?: string | undefined;
    sourceCodeUrl?: string | undefined;
    startMonth?: string | undefined;
    startYear?: string | undefined;

    constructor(data?: IProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.endMonth = _data["endMonth"];
            this.endYear = _data["endYear"];
            this.image1 = _data["image1"];
            this.image2 = _data["image2"];
            this.image3 = _data["image3"];
            this.logo = _data["logo"];
            this.projectName = _data["projectName"];
            this.projectUrl = _data["projectUrl"];
            this.repetitive = _data["repetitive"];
            this.role = _data["role"];
            this.sourceCodeUrl = _data["sourceCodeUrl"];
            this.startMonth = _data["startMonth"];
            this.startYear = _data["startYear"];
        }
    }

    static fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["endMonth"] = this.endMonth;
        data["endYear"] = this.endYear;
        data["image1"] = this.image1;
        data["image2"] = this.image2;
        data["image3"] = this.image3;
        data["logo"] = this.logo;
        data["projectName"] = this.projectName;
        data["projectUrl"] = this.projectUrl;
        data["repetitive"] = this.repetitive;
        data["role"] = this.role;
        data["sourceCodeUrl"] = this.sourceCodeUrl;
        data["startMonth"] = this.startMonth;
        data["startYear"] = this.startYear;
        return data;
    }
}

export interface IProject {
    description?: string | undefined;
    endMonth?: string | undefined;
    endYear?: string | undefined;
    image1?: string | undefined;
    image2?: string | undefined;
    image3?: string | undefined;
    logo?: string | undefined;
    projectName?: string | undefined;
    projectUrl?: string | undefined;
    repetitive?: boolean | undefined;
    role?: string | undefined;
    sourceCodeUrl?: string | undefined;
    startMonth?: string | undefined;
    startYear?: string | undefined;
}

export enum QuestionType {
    Multiple_choice = "multiple_choice",
    Single_choice = "single_choice",
    Descriptive = "descriptive",
}

export class ReportStructure implements IReportStructure {
    improvementAreas?: ImprovementAreas[] | undefined;
    nextSteps?: string[] | undefined;
    overview?: Overview | undefined;
    performanceSummary?: PerformanceSummary | undefined;
    recommendations?: Recommendations[] | undefined;
    skillBreakdown?: SkillBreakdown | undefined;
    strengths?: string[] | undefined;

    constructor(data?: IReportStructure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ImprovementAreas"])) {
                this.improvementAreas = [] as any;
                for (let item of _data["ImprovementAreas"])
                    this.improvementAreas!.push(ImprovementAreas.fromJS(item));
            }
            if (Array.isArray(_data["NextSteps"])) {
                this.nextSteps = [] as any;
                for (let item of _data["NextSteps"])
                    this.nextSteps!.push(item);
            }
            this.overview = _data["Overview"] ? Overview.fromJS(_data["Overview"]) : <any>undefined;
            this.performanceSummary = _data["PerformanceSummary"] ? PerformanceSummary.fromJS(_data["PerformanceSummary"]) : <any>undefined;
            if (Array.isArray(_data["Recommendations"])) {
                this.recommendations = [] as any;
                for (let item of _data["Recommendations"])
                    this.recommendations!.push(Recommendations.fromJS(item));
            }
            this.skillBreakdown = _data["SkillBreakdown"] ? SkillBreakdown.fromJS(_data["SkillBreakdown"]) : <any>undefined;
            if (Array.isArray(_data["Strengths"])) {
                this.strengths = [] as any;
                for (let item of _data["Strengths"])
                    this.strengths!.push(item);
            }
        }
    }

    static fromJS(data: any): ReportStructure {
        data = typeof data === 'object' ? data : {};
        let result = new ReportStructure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.improvementAreas)) {
            data["ImprovementAreas"] = [];
            for (let item of this.improvementAreas)
                data["ImprovementAreas"].push(item.toJSON());
        }
        if (Array.isArray(this.nextSteps)) {
            data["NextSteps"] = [];
            for (let item of this.nextSteps)
                data["NextSteps"].push(item);
        }
        data["Overview"] = this.overview ? this.overview.toJSON() : <any>undefined;
        data["PerformanceSummary"] = this.performanceSummary ? this.performanceSummary.toJSON() : <any>undefined;
        if (Array.isArray(this.recommendations)) {
            data["Recommendations"] = [];
            for (let item of this.recommendations)
                data["Recommendations"].push(item.toJSON());
        }
        data["SkillBreakdown"] = this.skillBreakdown ? this.skillBreakdown.toJSON() : <any>undefined;
        if (Array.isArray(this.strengths)) {
            data["Strengths"] = [];
            for (let item of this.strengths)
                data["Strengths"].push(item);
        }
        return data;
    }
}

export interface IReportStructure {
    improvementAreas?: ImprovementAreas[] | undefined;
    nextSteps?: string[] | undefined;
    overview?: Overview | undefined;
    performanceSummary?: PerformanceSummary | undefined;
    recommendations?: Recommendations[] | undefined;
    skillBreakdown?: SkillBreakdown | undefined;
    strengths?: string[] | undefined;
}

export enum SkillCategory {
    TECHNICAL = "TECHNICAL",
    SOFTSKILL = "SOFTSKILL",
    LANGUAGE = "LANGUAGE",
}

export enum Status {
    CREATED = "CREATED",
    IN_PROGRESS = "IN_PROGRESS",
    SUCCEEDED = "SUCCEEDED",
    FAILED = "FAILED",
}

export class SubTopic implements ISubTopic {
    conversation?: Conversation | undefined;
    generationFinished?: boolean | undefined;
    title?: string | undefined;

    constructor(data?: ISubTopic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversation = _data["conversation"] ? Conversation.fromJS(_data["conversation"]) : <any>undefined;
            this.generationFinished = _data["generationFinished"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): SubTopic {
        data = typeof data === 'object' ? data : {};
        let result = new SubTopic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversation"] = this.conversation ? this.conversation.toJSON() : <any>undefined;
        data["generationFinished"] = this.generationFinished;
        data["title"] = this.title;
        return data;
    }
}

export interface ISubTopic {
    conversation?: Conversation | undefined;
    generationFinished?: boolean | undefined;
    title?: string | undefined;
}

export class TopUp implements ITopUp {
    additional_data?: string | undefined;
    amount?: string | undefined;
    commission?: string | undefined;
    convert_amount?: string | undefined;
    convert_commission?: string | undefined;
    convert_rate?: string | undefined;
    convert_to_currency?: string | undefined;
    createdAt?: string | undefined;
    currency?: string | undefined;
    deletedAt?: DeletedAt | undefined;
    from?: string | undefined;
    id?: number | undefined;
    is_final?: boolean | undefined;
    merchant_amount?: string | undefined;
    network?: string | undefined;
    payer_currency?: string | undefined;
    payment_amount?: string | undefined;
    payment_amount_usd?: string | undefined;
    status?: string | undefined;
    txid?: string | undefined;
    updatedAt?: string | undefined;
    userID?: string | undefined;
    uuid?: string | undefined;
    wallet_address_uuid?: string | undefined;

    constructor(data?: ITopUp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additional_data = _data["additional_data"];
            this.amount = _data["amount"];
            this.commission = _data["commission"];
            this.convert_amount = _data["convert_amount"];
            this.convert_commission = _data["convert_commission"];
            this.convert_rate = _data["convert_rate"];
            this.convert_to_currency = _data["convert_to_currency"];
            this.createdAt = _data["createdAt"];
            this.currency = _data["currency"];
            this.deletedAt = _data["deletedAt"] ? DeletedAt.fromJS(_data["deletedAt"]) : <any>undefined;
            this.from = _data["from"];
            this.id = _data["id"];
            this.is_final = _data["is_final"];
            this.merchant_amount = _data["merchant_amount"];
            this.network = _data["network"];
            this.payer_currency = _data["payer_currency"];
            this.payment_amount = _data["payment_amount"];
            this.payment_amount_usd = _data["payment_amount_usd"];
            this.status = _data["status"];
            this.txid = _data["txid"];
            this.updatedAt = _data["updatedAt"];
            this.userID = _data["userID"];
            this.uuid = _data["uuid"];
            this.wallet_address_uuid = _data["wallet_address_uuid"];
        }
    }

    static fromJS(data: any): TopUp {
        data = typeof data === 'object' ? data : {};
        let result = new TopUp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additional_data"] = this.additional_data;
        data["amount"] = this.amount;
        data["commission"] = this.commission;
        data["convert_amount"] = this.convert_amount;
        data["convert_commission"] = this.convert_commission;
        data["convert_rate"] = this.convert_rate;
        data["convert_to_currency"] = this.convert_to_currency;
        data["createdAt"] = this.createdAt;
        data["currency"] = this.currency;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toJSON() : <any>undefined;
        data["from"] = this.from;
        data["id"] = this.id;
        data["is_final"] = this.is_final;
        data["merchant_amount"] = this.merchant_amount;
        data["network"] = this.network;
        data["payer_currency"] = this.payer_currency;
        data["payment_amount"] = this.payment_amount;
        data["payment_amount_usd"] = this.payment_amount_usd;
        data["status"] = this.status;
        data["txid"] = this.txid;
        data["updatedAt"] = this.updatedAt;
        data["userID"] = this.userID;
        data["uuid"] = this.uuid;
        data["wallet_address_uuid"] = this.wallet_address_uuid;
        return data;
    }
}

export interface ITopUp {
    additional_data?: string | undefined;
    amount?: string | undefined;
    commission?: string | undefined;
    convert_amount?: string | undefined;
    convert_commission?: string | undefined;
    convert_rate?: string | undefined;
    convert_to_currency?: string | undefined;
    createdAt?: string | undefined;
    currency?: string | undefined;
    deletedAt?: DeletedAt | undefined;
    from?: string | undefined;
    id?: number | undefined;
    is_final?: boolean | undefined;
    merchant_amount?: string | undefined;
    network?: string | undefined;
    payer_currency?: string | undefined;
    payment_amount?: string | undefined;
    payment_amount_usd?: string | undefined;
    status?: string | undefined;
    txid?: string | undefined;
    updatedAt?: string | undefined;
    userID?: string | undefined;
    uuid?: string | undefined;
    wallet_address_uuid?: string | undefined;
}

export class Topic implements ITopic {
    subTopics?: SubTopic[] | undefined;
    title?: string | undefined;

    constructor(data?: ITopic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["subTopics"])) {
                this.subTopics = [] as any;
                for (let item of _data["subTopics"])
                    this.subTopics!.push(SubTopic.fromJS(item));
            }
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): Topic {
        data = typeof data === 'object' ? data : {};
        let result = new Topic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subTopics)) {
            data["subTopics"] = [];
            for (let item of this.subTopics)
                data["subTopics"].push(item.toJSON());
        }
        data["title"] = this.title;
        return data;
    }
}

export interface ITopic {
    subTopics?: SubTopic[] | undefined;
    title?: string | undefined;
}

export class TrainingCourse implements ITrainingCourse {
    category?: string | undefined;
    createdAt?: string | undefined;
    description?: string | undefined;
    id?: number | undefined;
    skill?: string | undefined;
    title?: string | undefined;
    topic?: Topic[] | undefined;
    totalQuestions?: number | undefined;
    updatedAt?: string | undefined;
    userId?: string | undefined;

    constructor(data?: ITrainingCourse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.createdAt = _data["createdAt"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.skill = _data["skill"];
            this.title = _data["title"];
            if (Array.isArray(_data["topic"])) {
                this.topic = [] as any;
                for (let item of _data["topic"])
                    this.topic!.push(Topic.fromJS(item));
            }
            this.totalQuestions = _data["totalQuestions"];
            this.updatedAt = _data["updatedAt"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): TrainingCourse {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCourse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["createdAt"] = this.createdAt;
        data["description"] = this.description;
        data["id"] = this.id;
        data["skill"] = this.skill;
        data["title"] = this.title;
        if (Array.isArray(this.topic)) {
            data["topic"] = [];
            for (let item of this.topic)
                data["topic"].push(item.toJSON());
        }
        data["totalQuestions"] = this.totalQuestions;
        data["updatedAt"] = this.updatedAt;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ITrainingCourse {
    category?: string | undefined;
    createdAt?: string | undefined;
    description?: string | undefined;
    id?: number | undefined;
    skill?: string | undefined;
    title?: string | undefined;
    topic?: Topic[] | undefined;
    totalQuestions?: number | undefined;
    updatedAt?: string | undefined;
    userId?: string | undefined;
}

export class Transaction implements ITransaction {
    amount?: number | undefined;
    createdAt?: string | undefined;
    deletedAt?: DeletedAt | undefined;
    details?: TransactionDetails | undefined;
    id?: number | undefined;
    product?: BillingProduct | undefined;
    type?: TransactionType | undefined;
    updatedAt?: string | undefined;
    userId?: string | undefined;

    constructor(data?: ITransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.createdAt = _data["createdAt"];
            this.deletedAt = _data["deletedAt"] ? DeletedAt.fromJS(_data["deletedAt"]) : <any>undefined;
            this.details = _data["details"] ? TransactionDetails.fromJS(_data["details"]) : <any>undefined;
            this.id = _data["id"];
            this.product = _data["product"];
            this.type = _data["type"];
            this.updatedAt = _data["updatedAt"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): Transaction {
        data = typeof data === 'object' ? data : {};
        let result = new Transaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["createdAt"] = this.createdAt;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toJSON() : <any>undefined;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["product"] = this.product;
        data["type"] = this.type;
        data["updatedAt"] = this.updatedAt;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ITransaction {
    amount?: number | undefined;
    createdAt?: string | undefined;
    deletedAt?: DeletedAt | undefined;
    details?: TransactionDetails | undefined;
    id?: number | undefined;
    product?: BillingProduct | undefined;
    type?: TransactionType | undefined;
    updatedAt?: string | undefined;
    userId?: string | undefined;
}

export class TransactionDetails implements ITransactionDetails {
    imageSize?: string | undefined;
    textGeneration?: Usage | undefined;
    textToSpeechLength?: number | undefined;
    voiceSeconds?: number | undefined;

    constructor(data?: ITransactionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageSize = _data["imageSize"];
            this.textGeneration = _data["textGeneration"] ? Usage.fromJS(_data["textGeneration"]) : <any>undefined;
            this.textToSpeechLength = _data["textToSpeechLength"];
            this.voiceSeconds = _data["voiceSeconds"];
        }
    }

    static fromJS(data: any): TransactionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageSize"] = this.imageSize;
        data["textGeneration"] = this.textGeneration ? this.textGeneration.toJSON() : <any>undefined;
        data["textToSpeechLength"] = this.textToSpeechLength;
        data["voiceSeconds"] = this.voiceSeconds;
        return data;
    }
}

export interface ITransactionDetails {
    imageSize?: string | undefined;
    textGeneration?: Usage | undefined;
    textToSpeechLength?: number | undefined;
    voiceSeconds?: number | undefined;
}

export enum TransactionType {
    CHARGE = "CHARGE",
    AI_USAGE = "AI_USAGE",
}

export class User implements IUser {
    cmsId?: string | undefined;
    cmsUpdateVersion?: number | undefined;
    createdAt?: string | undefined;
    details?: UserDetails | undefined;
    id?: string | undefined;
    isCompany?: boolean | undefined;
    updatedAt?: string | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cmsId = _data["cmsId"];
            this.cmsUpdateVersion = _data["cmsUpdateVersion"];
            this.createdAt = _data["createdAt"];
            this.details = _data["details"] ? UserDetails.fromJS(_data["details"]) : <any>undefined;
            this.id = _data["id"];
            this.isCompany = _data["isCompany"];
            this.updatedAt = _data["updatedAt"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cmsId"] = this.cmsId;
        data["cmsUpdateVersion"] = this.cmsUpdateVersion;
        data["createdAt"] = this.createdAt;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["isCompany"] = this.isCompany;
        data["updatedAt"] = this.updatedAt;
        return data;
    }
}

export interface IUser {
    cmsId?: string | undefined;
    cmsUpdateVersion?: number | undefined;
    createdAt?: string | undefined;
    details?: UserDetails | undefined;
    id?: string | undefined;
    isCompany?: boolean | undefined;
    updatedAt?: string | undefined;
}

export class UserDetails implements IUserDetails {
    assessmentTypes?: AssessmentType[] | undefined;
    certificates?: Certificate[] | undefined;
    courses?: UserTrainingCourse[] | undefined;
    education?: Education[] | undefined;
    experiences?: Experience[] | undefined;
    interviewTypes?: InterviewType[] | undefined;
    jobPreference?: JobPreference | undefined;
    profile?: UserProfile | undefined;
    projects?: Project[] | undefined;

    constructor(data?: IUserDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assessmentTypes"])) {
                this.assessmentTypes = [] as any;
                for (let item of _data["assessmentTypes"])
                    this.assessmentTypes!.push(AssessmentType.fromJS(item));
            }
            if (Array.isArray(_data["certificates"])) {
                this.certificates = [] as any;
                for (let item of _data["certificates"])
                    this.certificates!.push(Certificate.fromJS(item));
            }
            if (Array.isArray(_data["courses"])) {
                this.courses = [] as any;
                for (let item of _data["courses"])
                    this.courses!.push(UserTrainingCourse.fromJS(item));
            }
            if (Array.isArray(_data["education"])) {
                this.education = [] as any;
                for (let item of _data["education"])
                    this.education!.push(Education.fromJS(item));
            }
            if (Array.isArray(_data["experiences"])) {
                this.experiences = [] as any;
                for (let item of _data["experiences"])
                    this.experiences!.push(Experience.fromJS(item));
            }
            if (Array.isArray(_data["interviewTypes"])) {
                this.interviewTypes = [] as any;
                for (let item of _data["interviewTypes"])
                    this.interviewTypes!.push(InterviewType.fromJS(item));
            }
            this.jobPreference = _data["jobPreference"] ? JobPreference.fromJS(_data["jobPreference"]) : <any>undefined;
            this.profile = _data["profile"] ? UserProfile.fromJS(_data["profile"]) : <any>undefined;
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(Project.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDetails {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assessmentTypes)) {
            data["assessmentTypes"] = [];
            for (let item of this.assessmentTypes)
                data["assessmentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.certificates)) {
            data["certificates"] = [];
            for (let item of this.certificates)
                data["certificates"].push(item.toJSON());
        }
        if (Array.isArray(this.courses)) {
            data["courses"] = [];
            for (let item of this.courses)
                data["courses"].push(item.toJSON());
        }
        if (Array.isArray(this.education)) {
            data["education"] = [];
            for (let item of this.education)
                data["education"].push(item.toJSON());
        }
        if (Array.isArray(this.experiences)) {
            data["experiences"] = [];
            for (let item of this.experiences)
                data["experiences"].push(item.toJSON());
        }
        if (Array.isArray(this.interviewTypes)) {
            data["interviewTypes"] = [];
            for (let item of this.interviewTypes)
                data["interviewTypes"].push(item.toJSON());
        }
        data["jobPreference"] = this.jobPreference ? this.jobPreference.toJSON() : <any>undefined;
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserDetails {
    assessmentTypes?: AssessmentType[] | undefined;
    certificates?: Certificate[] | undefined;
    courses?: UserTrainingCourse[] | undefined;
    education?: Education[] | undefined;
    experiences?: Experience[] | undefined;
    interviewTypes?: InterviewType[] | undefined;
    jobPreference?: JobPreference | undefined;
    profile?: UserProfile | undefined;
    projects?: Project[] | undefined;
}

export class UserProfile implements IUserProfile {
    availability?: string | undefined;
    defaultLanguage?: string | undefined;
    description?: string | undefined;
    email?: string | undefined;
    englishProficiency?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    overallExp?: string | undefined;
    phoneNumber?: string | undefined;
    profileGitHub?: string | undefined;
    profileImage?: string | undefined;
    profileLinkedIn?: string | undefined;
    profilePortfolio?: string | undefined;
    profileTwitter?: string | undefined;
    remoteExp?: string | undefined;
    role?: string | undefined;
    seniority?: string | undefined;
    skills?: string[] | undefined;
    verifiedSkills?: VerifiedSkill[] | undefined;

    constructor(data?: IUserProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availability = _data["availability"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.description = _data["description"];
            this.email = _data["email"];
            this.englishProficiency = _data["englishProficiency"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.overallExp = _data["overallExp"];
            this.phoneNumber = _data["phoneNumber"];
            this.profileGitHub = _data["profileGitHub"];
            this.profileImage = _data["profileImage"];
            this.profileLinkedIn = _data["profileLinkedIn"];
            this.profilePortfolio = _data["profilePortfolio"];
            this.profileTwitter = _data["profileTwitter"];
            this.remoteExp = _data["remoteExp"];
            this.role = _data["role"];
            this.seniority = _data["seniority"];
            if (Array.isArray(_data["skills"])) {
                this.skills = [] as any;
                for (let item of _data["skills"])
                    this.skills!.push(item);
            }
            if (Array.isArray(_data["verifiedSkills"])) {
                this.verifiedSkills = [] as any;
                for (let item of _data["verifiedSkills"])
                    this.verifiedSkills!.push(VerifiedSkill.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserProfile {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availability"] = this.availability;
        data["defaultLanguage"] = this.defaultLanguage;
        data["description"] = this.description;
        data["email"] = this.email;
        data["englishProficiency"] = this.englishProficiency;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["overallExp"] = this.overallExp;
        data["phoneNumber"] = this.phoneNumber;
        data["profileGitHub"] = this.profileGitHub;
        data["profileImage"] = this.profileImage;
        data["profileLinkedIn"] = this.profileLinkedIn;
        data["profilePortfolio"] = this.profilePortfolio;
        data["profileTwitter"] = this.profileTwitter;
        data["remoteExp"] = this.remoteExp;
        data["role"] = this.role;
        data["seniority"] = this.seniority;
        if (Array.isArray(this.skills)) {
            data["skills"] = [];
            for (let item of this.skills)
                data["skills"].push(item);
        }
        if (Array.isArray(this.verifiedSkills)) {
            data["verifiedSkills"] = [];
            for (let item of this.verifiedSkills)
                data["verifiedSkills"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserProfile {
    availability?: string | undefined;
    defaultLanguage?: string | undefined;
    description?: string | undefined;
    email?: string | undefined;
    englishProficiency?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    overallExp?: string | undefined;
    phoneNumber?: string | undefined;
    profileGitHub?: string | undefined;
    profileImage?: string | undefined;
    profileLinkedIn?: string | undefined;
    profilePortfolio?: string | undefined;
    profileTwitter?: string | undefined;
    remoteExp?: string | undefined;
    role?: string | undefined;
    seniority?: string | undefined;
    skills?: string[] | undefined;
    verifiedSkills?: VerifiedSkill[] | undefined;
}

export class UserTrainingCourse implements IUserTrainingCourse {
    category?: string | undefined;
    description?: string | undefined;
    skill?: string | undefined;
    title?: string | undefined;
    totalQuestions?: number | undefined;

    constructor(data?: IUserTrainingCourse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.description = _data["description"];
            this.skill = _data["skill"];
            this.title = _data["title"];
            this.totalQuestions = _data["totalQuestions"];
        }
    }

    static fromJS(data: any): UserTrainingCourse {
        data = typeof data === 'object' ? data : {};
        let result = new UserTrainingCourse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["description"] = this.description;
        data["skill"] = this.skill;
        data["title"] = this.title;
        data["totalQuestions"] = this.totalQuestions;
        return data;
    }
}

export interface IUserTrainingCourse {
    category?: string | undefined;
    description?: string | undefined;
    skill?: string | undefined;
    title?: string | undefined;
    totalQuestions?: number | undefined;
}

export class VerifiedSkill implements IVerifiedSkill {
    category?: SkillCategory | undefined;
    iconURL?: string | undefined;
    summaryOfLastAssessment?: string | undefined;
    title?: string | undefined;
    /** out of 100 */
    userScore?: number | undefined;

    constructor(data?: IVerifiedSkill) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.iconURL = _data["iconURL"];
            this.summaryOfLastAssessment = _data["summaryOfLastAssessment"];
            this.title = _data["title"];
            this.userScore = _data["userScore"];
        }
    }

    static fromJS(data: any): VerifiedSkill {
        data = typeof data === 'object' ? data : {};
        let result = new VerifiedSkill();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["iconURL"] = this.iconURL;
        data["summaryOfLastAssessment"] = this.summaryOfLastAssessment;
        data["title"] = this.title;
        data["userScore"] = this.userScore;
        return data;
    }
}

export interface IVerifiedSkill {
    category?: SkillCategory | undefined;
    iconURL?: string | undefined;
    summaryOfLastAssessment?: string | undefined;
    title?: string | undefined;
    /** out of 100 */
    userScore?: number | undefined;
}

export enum SpeechVoice {
    Alloy = "alloy",
    Echo = "echo",
    Fable = "fable",
    Onyx = "onyx",
    Nova = "nova",
    Shimmer = "shimmer",
}

export class Usage implements IUsage {
    completion_tokens?: number | undefined;
    prompt_tokens?: number | undefined;
    total_tokens?: number | undefined;

    constructor(data?: IUsage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completion_tokens = _data["completion_tokens"];
            this.prompt_tokens = _data["prompt_tokens"];
            this.total_tokens = _data["total_tokens"];
        }
    }

    static fromJS(data: any): Usage {
        data = typeof data === 'object' ? data : {};
        let result = new Usage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completion_tokens"] = this.completion_tokens;
        data["prompt_tokens"] = this.prompt_tokens;
        data["total_tokens"] = this.total_tokens;
        return data;
    }
}

export interface IUsage {
    completion_tokens?: number | undefined;
    prompt_tokens?: number | undefined;
    total_tokens?: number | undefined;
}

export enum TalkStatus {
    Created = "created",
    Done = "done",
    Error = "error",
    Started = "started",
    Rejected = "rejected",
}

/** Transaction type */
export enum Transaction_type {
    CHARGE = "CHARGE",
    AI_USAGE = "AI_USAGE",
}

/** Filter files by source (optional) */
export enum Source {
    GENERATE_INTERVIEW = "GENERATE_INTERVIEW",
}

/** Category Type */
export enum CategoryType {
    GENERAL = "GENERAL",
    JOB = "JOB",
}

/** Category Type */
export enum CategoryType2 {
    GENERAL = "GENERAL",
    JOB = "JOB",
}

/** Category Type */
export enum CategoryType3 {
    GENERAL = "GENERAL",
    JOB = "JOB",
}

/** Filter files by source (optional) */
export enum Source2 {
    GENERATE_INTERVIEW = "GENERATE_INTERVIEW",
}

export class ImprovementAreas implements IImprovementAreas {
    score?: number | undefined;
    skill?: string | undefined;

    constructor(data?: IImprovementAreas) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["Score"];
            this.skill = _data["Skill"];
        }
    }

    static fromJS(data: any): ImprovementAreas {
        data = typeof data === 'object' ? data : {};
        let result = new ImprovementAreas();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Score"] = this.score;
        data["Skill"] = this.skill;
        return data;
    }
}

export interface IImprovementAreas {
    score?: number | undefined;
    skill?: string | undefined;
}

export class Overview implements IOverview {
    assessmentPurpose?: string | undefined;
    scope?: string | undefined;

    constructor(data?: IOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentPurpose = _data["AssessmentPurpose"];
            this.scope = _data["Scope"];
        }
    }

    static fromJS(data: any): Overview {
        data = typeof data === 'object' ? data : {};
        let result = new Overview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AssessmentPurpose"] = this.assessmentPurpose;
        data["Scope"] = this.scope;
        return data;
    }
}

export interface IOverview {
    assessmentPurpose?: string | undefined;
    scope?: string | undefined;
}

export class PerformanceSummary implements IPerformanceSummary {
    completionTime?: string | undefined;
    summaryOfAssessment?: string | undefined;
    totalScore?: number | undefined;

    constructor(data?: IPerformanceSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completionTime = _data["CompletionTime"];
            this.summaryOfAssessment = _data["SummaryOfAssessment"];
            this.totalScore = _data["TotalScore"];
        }
    }

    static fromJS(data: any): PerformanceSummary {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CompletionTime"] = this.completionTime;
        data["SummaryOfAssessment"] = this.summaryOfAssessment;
        data["TotalScore"] = this.totalScore;
        return data;
    }
}

export interface IPerformanceSummary {
    completionTime?: string | undefined;
    summaryOfAssessment?: string | undefined;
    totalScore?: number | undefined;
}

export class Recommendations implements IRecommendations {
    skill?: string | undefined;
    suggestedResources?: string[] | undefined;

    constructor(data?: IRecommendations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skill = _data["Skill"];
            if (Array.isArray(_data["SuggestedResources"])) {
                this.suggestedResources = [] as any;
                for (let item of _data["SuggestedResources"])
                    this.suggestedResources!.push(item);
            }
        }
    }

    static fromJS(data: any): Recommendations {
        data = typeof data === 'object' ? data : {};
        let result = new Recommendations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Skill"] = this.skill;
        if (Array.isArray(this.suggestedResources)) {
            data["SuggestedResources"] = [];
            for (let item of this.suggestedResources)
                data["SuggestedResources"].push(item);
        }
        return data;
    }
}

export interface IRecommendations {
    skill?: string | undefined;
    suggestedResources?: string[] | undefined;
}

export class SkillBreakdown implements ISkillBreakdown {
    coreSkillsEvaluated?: CoreSkillsEvaluated[] | undefined;

    constructor(data?: ISkillBreakdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["CoreSkillsEvaluated"])) {
                this.coreSkillsEvaluated = [] as any;
                for (let item of _data["CoreSkillsEvaluated"])
                    this.coreSkillsEvaluated!.push(CoreSkillsEvaluated.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SkillBreakdown {
        data = typeof data === 'object' ? data : {};
        let result = new SkillBreakdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.coreSkillsEvaluated)) {
            data["CoreSkillsEvaluated"] = [];
            for (let item of this.coreSkillsEvaluated)
                data["CoreSkillsEvaluated"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISkillBreakdown {
    coreSkillsEvaluated?: CoreSkillsEvaluated[] | undefined;
}

export class CoreSkillsEvaluated implements ICoreSkillsEvaluated {
    score?: number | undefined;
    skill?: string | undefined;

    constructor(data?: ICoreSkillsEvaluated) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["Score"];
            this.skill = _data["Skill"];
        }
    }

    static fromJS(data: any): CoreSkillsEvaluated {
        data = typeof data === 'object' ? data : {};
        let result = new CoreSkillsEvaluated();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Score"] = this.score;
        data["Skill"] = this.skill;
        return data;
    }
}

export interface ICoreSkillsEvaluated {
    score?: number | undefined;
    skill?: string | undefined;
}
//-----/CustomTypes.File-----

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

export function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

//-----/Types.File-----

import { addResultTypeFactory } from './axios-client/helpers';
export { setBaseUrl, getBaseUrl } from './axios-client/helpers';
export { setAxiosFactory, getAxios } from './axios-client/helpers';
